import axios from "axios";
import store from "./vuex";
import Vue from "vue";
import {Loading} from "vue-ydui/dist/lib.rem/dialog";
import ElementUI from "element-ui";
import VueAxios from "vue-axios";

///*跨域帶上cookie認證
axios.defaults.withCredentials = true;
//  http request 攔截器
axios.interceptors.request.use(config => {
  config.headers['Authorization'] = '';
  // 判斷是否存在token，如果存在的話，則每個http header都加上token
  if(store.state.token)
  {
    config.headers['Authorization'] = "Bearer " + store.state.token;
  }
  else if(window.localStorage.getItem('token'))
  {
    config.headers['Authorization'] = "Bearer " + window.localStorage.getItem("token");
  }

  config.data.version = Vue.prototype.version.version;
  return config;
}, err => {
  console.log(err);
  return Promise.reject(err);
});

// http response 服務器響應攔截器，攔截401錯誤，重新登錄
axios.interceptors.response.use(response => {
  //超時前壹小段時間，返回需要刷新jwt
  if(response.data.needrefreshjwt)
  {
    window.vm.refreshJwt();
  }
  if(response.data.code === 401 || response.data.code === 408)
  {
    Vue.prototype.$notify({
      title: '警告', message: '請重新登錄', type: 'warning'
    })

    window.vm.$router.push({name: 'login'});
  }
  if(response.data.versionLow)
  {
    Vue.prototype.$notify({
      title: '警告', message: '版本過舊，請刷新網頁！', type: 'warning'
    })
  }

  return response;
}, error => {
  Loading.close();
  ElementUI.Notification({
    title: '警告', message: '系統錯誤，請稍後重試！', type: 'warning', duration: 0
  });
});

Vue.use(VueAxios, axios)

export default axios



// WEBPACK FOOTER //
// ./src/commonality/http.js